import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
//import { JobsForm } from './jobs-form';
//import { JobsFilter } from './jobs-filter';
import { RenderFilters } from '../../../elements/render-filters';
import { ShipmentForm } from './shipment-form';


export const Shipments = () => {
    const { open, close } = useDrawer();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>({});
    const [query, setQuery] = useState<any>(new URLSearchParams(filters));




    const handleNewAction = () => {
        navigate('/shipments/create')
    };



    const handleFilters = () => {
        //open('common.filter.title', <JobsFilter close={close} doFilter={doFilter} item={filters} />);
    };

    const doFilter = (filters: any) => {
        setFilters(filters);
        // Actualizar el query inmediatamente con los nuevos filtros
        setQuery(new URLSearchParams(filters));
        // Resetear la paginación cuando se aplica un filtro
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.transporte'}
            newActionTitle={'common.form-title.new'}
            //filterAction={handleFilters}
            //filters={filters}
        >
            <>

                {Object.keys(filters).length > 0 ? (
                    <RenderFilters filters={filters} />
                ) : (
                    ''
                )}
                <Table
                    path="/fleet/shipments/"
                    deletePath="/fleet/shipments/"
                    Form={ShipmentForm}
                    withPagination
                    doEdit={(item: any) => navigate(`/shipments/${item.id}`)}
                    query={query}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'pickup_address',
                            label: 'common.label.pickup-address'
                        },
                        {
                            key: 'pickup_city',
                            label: 'common.label.pickup-city'
                        },
                        {
                            key: 'delivery_address',
                            label: 'common.label.delivery-address'
                        },
                        
                        {
                            key: 'delivery_city',
                            label: 'common.label.delivery-city'
                        },
                        {
                            key: 'status',
                            label: 'common.label.estado'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};